import React, { useState } from 'react'
import { ChevronDown, ChevronUp } from 'react-feather';

interface SelectProps {
  placeholder: string;
  options: string[];
  selectedValue: number | string;
  handleOptionClick: (value: string) => void;
}

const SelectInputComponent: React.FC<SelectProps> = ({options, 
                                                      selectedValue,
                                                      handleOptionClick}) => {

  return (
    <div className='flex flex-row items-center'>
      <select
        value={selectedValue}
        onChange={(e) => handleOptionClick(e.target.value)}
        className="px-3 py-1.5 bg-dark-input border border-dark-border text-sm rounded-xl text-white focus:outline-none focus:border-accent-teal transition-colors cursor-pointer"
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  )
}

export default SelectInputComponent
